import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import { Link } from "react-router-dom";
import Select from "react-select";

import axiosInstance from "utils/axiosInstance";

// redux
import { useSelector } from "react-redux";

/*---- Current Month Component ----*/
const CurrentMonthComponent = ({viewMode}) => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth() + 1;

  // Format the date as 'YYYY 年 M 月'
  const formattedDate = `${year} 年 ${month} 月`;
  return viewMode === "platform" ? (
    <p className="text-muted">{formattedDate} - 全平台用戶用量：</p>
  ) : (
    <p className="text-muted">{formattedDate} - 我的用量：</p>
  )
  
};
/*---- Current Month Component Tail ----*/

const MonthlyEarning = () => {
  const [availWordPercentage, setAvailWordPercentage] = useState(0);
  const [availProjectPercentage, setAvailProjectPercentage] = useState(0);
  const [viewMode, setViewMode] = useState("user"); // Default to user usage
  const [usageData, setUsageData] = useState([]); // State to hold fetched usage data
  const [currentMonthData, setCurrentMonthData] = useState({});
  const [lastMonthData, setLastMonthData] = useState({});
  const [platformCurrentMonthData, setPlatformCurrentMonthData] = useState({});
  const [platformLastMonthData, setPlatformLastMonthData] = useState({});

  const userData = useSelector((state) => state.user.userData);

  const viewOptions = [
    { value: "user", label: "我的" },
    { value: "platform", label: "全平台" },
  ];

  const fetchUserStatsHistory = async () => {
    try {
      const response = await axiosInstance.get(`/knovia/user-recent-history`);
      return response.data.history; // Return the history array
    } catch (error) {
      console.error("Error fetching user stats history:", error);
      return [];
    }
  };

  const fetchPlatformStats = async () => {
    try {
      const response = await axiosInstance.get("/knovia/platform-recent-history");
      return response.data.platformStats;
    } catch (error) {
      console.error("Error fetching platform stats:", error);
      return [];
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1; // Months are 0-indexed
      const currentYear = currentDate.getFullYear();

      const lastMonth = currentMonth === 1 ? 12 : currentMonth - 1;
      const lastMonthYear = currentMonth === 1 ? currentYear - 1 : currentYear;

      if (viewMode === "user") {
        const history = await fetchUserStatsHistory();
        setUsageData(history);

        const currentMonthStats = history.find(
          (record) => record.month === currentMonth && record.year === currentYear
        );
        const lastMonthStats = history.find(
          (record) => record.month === lastMonth && record.year === lastMonthYear
        );

        console.log("User Current Month Stats:", currentMonthStats);
        console.log("User Last Month Stats:", lastMonthStats);

        setCurrentMonthData(currentMonthStats || {});
        setLastMonthData(lastMonthStats || {});
      } else if (viewMode === "platform") {
        const platformStats = await fetchPlatformStats();

        const platformCurrentMonthStats = platformStats.find(
          (record) => record._id.month === currentMonth && record._id.year === currentYear
        );
        const platformLastMonthStats = platformStats.find(
          (record) =>
            record._id.month === lastMonth && record._id.year === lastMonthYear
        );

        console.log("Platform Current Month Stats:", platformCurrentMonthStats);
        console.log("Platform Last Month Stats:", platformLastMonthStats);

        setPlatformCurrentMonthData(platformCurrentMonthStats || {});
        setPlatformLastMonthData(platformLastMonthStats || {});
      }
    };

    fetchData();
  }, [viewMode]);



  useEffect(() => {
    if (userData?.stats?.wordThisMonth != null && userData?.projects?.length != null) {
      const packageWordCount = userData.isPremiumUser ? 50000 : 3000;
      const wordPercentage = (userData.stats.wordThisMonth / packageWordCount) * 100;
      setAvailWordPercentage(wordPercentage);

      const packageProjectLimit = userData.isPremiumUser ? 100 : 10;
      const projectPercentage =
        ((packageProjectLimit - userData.projects.length) / packageProjectLimit) * 100;
      setAvailProjectPercentage(projectPercentage);
    }
  }, [userData]);



  useEffect(() => {
    console.log("availWordPercentage:", availWordPercentage);
    console.log("availProjectPercentage:", availProjectPercentage);
  }, [availWordPercentage, availProjectPercentage]);

  const handleViewChange = (selectedOption) => {
    setViewMode(selectedOption.value);
    console.log("Selected view:", selectedOption.value);
  };

  return (
    <React.Fragment>
      <Card>
        <CardBody style={{ padding: "2.5rem 1.5rem 4rem 1.5rem" }}>


          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <CardTitle className="mb-4">使用量總覽（beta）</CardTitle>
            <Select
              options={viewOptions}
              defaultValue={viewOptions[0]}
              onChange={handleViewChange}
              isSearchable={false} // Disable text input indicator
              styles={{
                container: (provided) => ({
                  ...provided,
                  width: "150px",
                }),
              }}
            />
          </div>


          <Row>
            <Col sm="12">
              <CurrentMonthComponent viewMode={viewMode}/>

              <hr style={{ borderTop: "1px solid #979797" }} />

              {viewMode === "platform" ? (
                <>
                  <h5>
                    本月翻譯字數：{(platformCurrentMonthData.totalWordsTranslated || 0).toLocaleString()} 字
                  </h5>
                  <p className="text-muted">
                    與上月相比{" "}
                    <span
                      className="text-warning me-2"
                      style={{ marginLeft: "0.4vw" }}
                    >
                      {platformLastMonthData.totalWordsTranslated
                        ? `${(
                            (
                              ((platformCurrentMonthData.totalWordsTranslated || 0) -
                                platformLastMonthData.totalWordsTranslated) /
                              platformLastMonthData.totalWordsTranslated
                            ) * 100
                          ).toFixed(1)}%`
                        : "N/A"}{" "}
                      <i
                        className={`mdi ${
                          platformCurrentMonthData.totalWordsTranslated >
                          platformLastMonthData.totalWordsTranslated
                            ? "mdi-arrow-up"
                            : "mdi-arrow-down"
                        }`}
                      ></i>{" "}
                    </span>
                  </p>

                  <hr style={{ borderTop: "1px solid #979797" }} />

                  <h5>
                    本月對話字數：{(platformCurrentMonthData.totalConversationWordCount || 0).toLocaleString()} 字
                  </h5>
                  <p className="text-muted">
                    與上月相比{" "}
                    <span
                      className="text-success me-2"
                      style={{ marginLeft: "0.4vw" }}
                    >
                      {platformLastMonthData.totalConversationWordCount
                        ? `${(
                            (
                              ((platformCurrentMonthData.totalConversationWordCount || 0) -
                                platformLastMonthData.totalConversationWordCount) /
                              platformLastMonthData.totalConversationWordCount
                            ) * 100
                          ).toFixed(1)}%`
                        : "N/A"}{" "}
                      <i
                        className={`mdi ${
                          platformCurrentMonthData.totalConversationWordCount >
                          platformLastMonthData.totalConversationWordCount
                            ? "mdi-arrow-up"
                            : "mdi-arrow-down"
                        }`}
                      ></i>{" "}
                    </span>
                  </p>
                </>
              ) : (
                <>
                  <h5>
                    本月翻譯字數：{(currentMonthData.wordsTranslated || 0).toLocaleString()} 字
                  </h5>
                  <p className="text-muted">
                    與上月相比{" "}
                    <span className="text-warning me-2" style={{ marginLeft: "0.4vw" }}>
                      {lastMonthData.wordsTranslated
                        ? `${((
                            ((currentMonthData.wordsTranslated || 0) -
                              lastMonthData.wordsTranslated) /
                            lastMonthData.wordsTranslated) * 100
                          ).toFixed(1)}%`
                        : "N/A"}{" "}
                      <i
                        className={`mdi ${
                          currentMonthData.wordsTranslated > lastMonthData.wordsTranslated
                            ? "mdi-arrow-up"
                            : "mdi-arrow-down"
                        }`}
                      ></i>{" "}
                    </span>
                  </p>

                  <hr style={{ borderTop: "1px solid #979797" }} />

                  <h5>
                    本月對話字數：{(currentMonthData.conversationWordCount || 0).toLocaleString()} 字
                  </h5>
                  <p className="text-muted">
                    與上月相比{" "}
                    <span className="text-success me-2" style={{ marginLeft: "0.4vw" }}>
                      {lastMonthData.conversationWordCount
                        ? `${((
                            ((currentMonthData.conversationWordCount || 0) - lastMonthData.conversationWordCount) /
                            lastMonthData.conversationWordCount) * 100
                          ).toFixed(1)}%`
                        : "N/A"}{" "}
                      <i
                        className={`mdi ${
                          currentMonthData.conversationWordCount > lastMonthData.conversationWordCount
                            ? "mdi-arrow-up"
                            : "mdi-arrow-down"
                        }`}
                      ></i>{" "}
                    </span>
                  </p>
                </>
              )}

              <hr style={{ borderTop: "1px solid #979797" }} />
            </Col>

            <Col sm="12" style={{ margin:'2rem 0rem 0rem 0rem' }}>
              <p
                className="text-muted"
                style={{ 
                  margin: "2vh 0vw 1vh 0vw",
                  fontSize: "15px",
                  margin: "0 0 7px 0",
                  fontWeight: "600"
                }}
              >
                我的用量
              </p>
            </Col>

            <Col
              sm="12"
              style={{
                padding: "0rem",
                margin: "-0.5rem 0rem 0rem 0rem",
                //margin:'0rem 0rem 0rem 0rem',
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
              }}
            >
            </Col>
          </Row>

          <Link
            to="https://bytelingo.co/pricing"
            target="_blank"
            className="text-dark"
          >
            <CardTitle
              className="text-muted mb-0"
              style={{ margin: "1.5rem 0rem" }}
            >
              了解方案用量{" "}
              <div className="arrow-icon">
                <i className="fas fa-arrow-right"></i>
              </div>
            </CardTitle>
          </Link>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default MonthlyEarning;
